import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const useUnsavedChanges = () => {
  const cart = useSelector((state) => state.cart);
  const orderTaker = useSelector((state) => state.orderTaker);

  const hasUnsavedChanges = useCallback(() => {
    const hasCartItems = cart?.cart && cart.cart.length > 0;
    const hasCustomerData = orderTaker?.customer;

    return hasCartItems || hasCustomerData;
  }, [cart, orderTaker]);

  return { hasUnsavedChanges };
};
